/* eslint-disable react/no-array-index-key */
import { List } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { SINGLE_GEN_DEVICE_NAV_LINK } from "../../../../router/routes"
import MobileListApplicationSkeleton from "../../../loading/skeletons/mobileListApplicationSkeleton"
import StatusChip from "../../../pills/status/statusChip"
import MobileListItems from "../../applicationTable/mobile/mobileListItems"
import { IDatabaseSearchResult } from "../genSearchResults"

interface IGenSearchResultsMobile {
    searchResults: IDatabaseSearchResult[]
    isLoading: boolean
}

const skeletonArray = Array.from({ length: 15 }, () => 0)

/**
 * Mobile friendly list of TTR devices
 */
const GenSearchResultsMobile = ({
    searchResults,
    isLoading,
}: IGenSearchResultsMobile): ReactElement => {
    const navigate = useNavigate()
    return (
        <List sx={{ pt: "0px" }}>
            {isLoading
                ? skeletonArray.map((_, index) => (
                      <MobileListApplicationSkeleton key={index} removeIcon />
                  ))
                : searchResults.map((device) => (
                      <MobileListItems
                          key={device.deviceReference}
                          title={device.deviceReference}
                          subtitle={device.manufacturer}
                          subtitleAdditional={device.type}
                          chipOverride={<StatusChip status={device.status} />}
                          chipText=""
                          onClick={() =>
                              navigate(
                                  SINGLE_GEN_DEVICE_NAV_LINK(
                                      device.deviceReference
                                  )
                              )
                          }
                      />
                  ))}
        </List>
    )
}
export default GenSearchResultsMobile
